import { LAYOUT } from '@admin/router/constant'

// 出库管理
const outboundRouter = {
  path: '/outbound-management',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/outbound-management/wave-strategy',
      name: 'waveStrategy',
      component: () => import('@admin/views/wms/outboundManagement/waveStrategy/index.vue'),
      meta: { title: '波次策略配置' },
    },
    {
      path: '/wave-strategy/edit',
      name: 'waveStrategyEdit',
      component: () => import('@admin/views/wms/outboundManagement/waveStrategy/edit.vue'),
      meta: { helpUrl: '', title: '波次策略新增/编辑' },
    },
    {
      path: '/outbound-management/sales-invoice',
      name: 'SalesInvoice',
      component: () => import('@admin/views/wms/outboundManagement/salesInvoice/index.vue'),
      meta: { title: '销售发货单' },
    },
    {
      path: '/distribution/invoice-edit',
      name: 'outboundManagementInvoiceEdit',
      component: () =>
        import('@admin/views/wms/outboundManagement/distributionManagement/invoice/edit/index.vue'),
      meta: { title: '拣货单详情' },
    },
    {
      path: '/distribution/invoice-task-list',
      name: 'invoiceTaskList',
      component: () =>
        import(
          '@admin/views/wms/outboundManagement/distributionManagement/invoiceTaskList/index.vue'
        ),
      meta: { title: '拣货任务' },
    },

    {
      path: '/inventory-management/warehouse-inventory',
      name: 'warehouseInventory',
      component: () =>
        import(
          '@admin/views/wms/outboundManagement/inventoryManagement/warehouseInventory/index.vue'
        ),
      meta: { title: '库存查询' },
    },
    {
      path: '/inventory-management/incoming-outgoing-logs',
      name: 'incomingOutgoingLogs',
      component: () =>
        import(
          '@admin/views/wms/outboundManagement/inventoryManagement/incomingOutgoingLogs/index.vue'
        ),
      meta: { title: '出入库日志' },
    },
    {
      path: '/inventory-management/stock-movement',
      name: 'stockMovement',
      component: () =>
        import('@admin/views/wms/outboundManagement/inventoryManagement/stockMovement/index.vue'),
      meta: { title: '库存移动' },
    },
    {
      path: '/inventory-management/goods-inventory',
      name: 'wmsGoodsInventory',
      component: () =>
        import('@admin/views/wms/outboundManagement/inventoryManagement/goodsInventory/index.vue'),
      meta: { title: '商品查询' },
    },
    {
      path: '/sorting/sorting-operation',
      name: 'sortingOperation',
      component: () =>
        import(
          '@admin/views/wms/outboundManagement/sortingManagement/sortingOperationV2/index.vue'
        ),
      meta: { title: '分拣作业' },
    },
    {
      path: '/exception-management/order-interception',
      name: 'orderInterception',
      component: () =>
        import(
          '@admin/views/wms/outboundManagement/exceptionManagement/orderInterception/index.vue'
        ),
      meta: { title: '订单拦截' },
    },
    {
      path: '/wms/exception-management/abnormal-delivery-order',
      name: 'WMSExceptionManagementAbnormalDeliveryOrder',
      component: () =>
        import(
          '@admin/views/wms/outboundManagement/exceptionManagement/abnormalDeliveryOrder/index.vue'
        ),
      meta: { title: '发货单异常' },
    },
    {
      path: '/warehouse-work/stock-movement',
      name: 'stockMovement',
      component: () =>
        import('@admin/views/wms/outboundManagement/inventoryManagement/stockMovement/index.vue'),
      meta: { title: '库存移动' },
    },
    {
      path: '/outbound-management/delivery-workbench',
      name: 'WMSDeliveryWorkbench',
      component: () => import('@admin/views/wms/outboundManagement/deliveryWorkbench/index.vue'),
      meta: { title: '配货工作台' },
    },
    {
      path: '/outbound-management/picking-list',
      name: 'WMSPickingList',
      component: () => import('@admin/views/wms/outboundManagement/pickingList/index.vue'),
      meta: { title: '拣货单' },
    },
    {
      path: '/wms/outbound-management/pre-sorting',
      name: 'WMSPreSorting',
      component: () => import('@admin/views/wms/outboundManagement/oneSort/index.vue'),
      meta: { title: '一分作业' },
    },
    {
      path: '/outbound-management/package-ship',
      name: 'WMSDeliveryPackageShip',
      component: () => import('@admin/views/wms/outboundManagement/packageShipV3/index.vue'),
      meta: { title: '发货作业' },
    },
    {
      path: '/wms/outbound-management/combinen-package',
      name: 'WMSCombinenPackage',
      component: () => import('@admin/views/wms/outboundManagement/combinenPackage/index.vue'),
      meta: { title: '合包发货单' },
    },
    {
      path: '/wms/outbound-management/consolidation-picking-list',
      name: 'WMSConsolidationPickingList',
      component: () =>
        import('@admin/views/wms/outboundManagement/pickingListConsolidation/index.vue'),
      meta: { title: '合包前序拣货单' },
    },
    {
      path: '/wms/outbound-management/consolidation-picking-details',
      name: 'WMSConsolidationPickingDetails',
      component: () =>
        import('@admin/views/wms/outboundManagement/pickingListConsolidation/edit/index.vue'),
      meta: { title: '合包前序拣货单详情' },
    },
  ],
}

export default [outboundRouter]
